//@flow

const radii = ['0rem', '0.25rem', '0.5rem', '0.75rem', '1rem']

exports.borders = { radii }
